"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Crud = void 0;
const Router_1 = require("../router/Router");
function Crud({ name, listComponent, readComponent, routes = [], privateRoute = true, }) {
    const { renderRoutes, useRouteMatch } = Router_1.useRouterContext();
    const match = useRouteMatch();
    if (!match) {
        return null;
    }
    const idParam = `:${name.charAt(0).toLowerCase() + name.slice(1)}Id`;
    // Add CRUD path prefix to given routes
    routes = routes.map((route) => {
        route.path = `${match.path}/${idParam}/${route.path}`;
        return route;
    });
    if (listComponent) {
        routes.push({
            exact: true,
            path: match.path,
            component: listComponent,
            privateRoute: privateRoute,
        });
    }
    if (readComponent) {
        routes.push({
            exact: true,
            path: `${match.path}/${idParam}`,
            component: readComponent,
            privateRoute: privateRoute,
        });
    }
    return renderRoutes(routes);
}
exports.Crud = Crud;
//# sourceMappingURL=Crud.js.map